import { useAppStore } from "@spiral-app/core";
const addTab = (path, params, options) => {
  const { tabsHandlers } = useAppStore.getState();
  let newPath = path;
  if (params) {
    newPath += "?" + new URLSearchParams(params);
  }
  tabsHandlers.add(newPath, options);
};
const removeTab = (path, options) => {
  return useAppStore.getState().tabsHandlers.remove(path, options);
};
const closeAll = () => {
  var _a;
  const { tabsHandlers } = useAppStore.getState();
  (_a = tabsHandlers.closeAll) == null ? void 0 : _a.call(tabsHandlers);
};
const getSearchParams = ({ parseBoolean = true, parseNumber = false } = {}) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const searchParams = {};
  for (const [key, value] of urlSearchParams) {
    let v = value;
    if (v === "null") {
      v = null;
    }
    if (v === "undefined") {
      v = void 0;
    }
    if (parseBoolean && (v === "true" || v === "false")) {
      v = v === "true" ? true : false;
    }
    if (parseNumber && !isNaN(Number(v))) {
      v = Number(v);
    }
    searchParams[key] = v;
  }
  return searchParams;
};
export {
  addTab,
  closeAll,
  getSearchParams,
  removeTab
};
